<template>
    <div class="component text-container">
        <div class="text-wrapper">
            <slot />
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TextContainer',
    };
</script>

<style lang="scss" scoped>
    .wrapper {
        padding: 150px 0 100px 0;
    }

    h1,
    h2 {
        line-height: 1.3em;
    }

    h1 {
        font-weight: font-weight('thin');
        font-size: 50px;
        margin-bottom: 50px;

        @media (max-width: breakpoint('medium')) {
            font-size: 35px;
        }
    }

    h2 {
        font-size: 24px;
        font-weight: font-weight('bold');
        margin-bottom: 20px;

        & + h3 {
            margin-top: 50px;
        }
    }

    h3 {
        font-size: 20px;
        margin-bottom: 20px;
    }

    p {
        & + h2 {
            margin-top: 70px;
        }

        & + h3 {
            margin-top: 50px;
        }
    }

    ul,
    ol {
        font-size: 18px;
        line-height: 1.65em;

        @media (max-width: breakpoint('small')) {
            line-height: 1.55em;
        }

        margin-bottom: 20px;

        & + h2 {
            margin-top: 70px;
        }

        li:not(:last-of-type) {
            margin-bottom: 10px;
        }
    }

    ol {
        &.style-alphabetical {
            list-style-type: lower-latin;
        }
    }

    a {
        color: color('magenta');
        font-weight: font-weight('bold');
        text-underline-position: under;
    }

    strong {
        font-weight: font-weight('bold');
    }

    .table-wrapper {
        width: 100%;
        position: relative;
        overflow-x: auto;
    }

    table {
        border-collapse: collapse;
        margin-bottom: 1rem;
        width: 100%;

        @media (max-width: breakpoint('medium')) {
            width: 768px;
        }

        td {
            vertical-align: top;
            padding: 15px 10px;

            &:nth-child(1) {
                width: 20%;
            }

            &:nth-child(2) {
                width: 30%;
            }

            &:nth-child(3) {
                width: 30%;
            }

            &:nth-child(4) {
                width: 20%;
            }
        }

        thead td {
            border-bottom: 1px solid #000;
            &:first-of-type {
                padding-left: 0;
            }
        }

        tbody td {
            border-bottom: 1px solid map-get($colors, 'gray-100');

            &:first-of-type {
                padding-left: 0;
            }
        }
    }
</style>
